import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { AppStateService } from '../services/app-state.service';
import { syliusLocale } from '../utils/i18n.utils';
import { targetApi } from '../utils/url.utils';

@Injectable()
export class SetLanguageInterceptor implements HttpInterceptor {
  private readonly _appState: AppStateService = inject(AppStateService);

  /**
   * Add language to the request header
   */
  public intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    if (
      request.method !== 'JSONP' &&
      !request.headers.get('Accept-Language') &&
      targetApi(request.url)
    ) {
      request = request.clone({
        setHeaders: {
          'Accept-Language': syliusLocale(this._appState.locale),
        },
      });
    }

    return next.handle(request);
  }
}
